import rewardsExpandedImg from '@images/logos/RewardsExpanded.png';

export const Rewards = () => (
  <div className="h-full overflow-auto hide-scrollbars select-none">
    <img src={rewardsExpandedImg} alt="rewards" />
  </div>
);
